import { isNumber } from 'shared/utils/is-number';
import { WordId } from 'shared/utils/nlp/get-ids-for-words';

export const getWordIndexFromMatch = (
  match: RegExpMatchArray,
  wordIds: WordId[],
): number => {
  const matchIndex = match.index;

  if (!isNumber(matchIndex)) {
    // no match, we return the last word index
    return wordIds.length - 1;
  }

  // Offsets must include the separator, or the map drifts one char per preceding space.
  let cursor = 0;
  const wordStartEndList = wordIds.map(({ word }) => {
    const start = cursor;
    const end = start + word.length;
    cursor = end + 1;
    return { start, end };
  });

  const res = wordStartEndList.findIndex(
    ({ start, end }) => matchIndex >= start && matchIndex <= end,
  );

  // if not found, return the last word index
  return res === -1 ? wordIds.length - 1 : res;
};
